import PropTypes from "prop-types";

import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import MDButton from "components/MDButton";

function HelpTooltip({ title, placement, sx }) {
  if (!title) return null;

  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 520,
            maxHeight: "70vh",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            fontSize: "0.75rem",
            lineHeight: 1.5,
          },
        },
      }}
    >
      <MDButton
        variant="outlined"
        color="secondary"
        size="small"
        circular
        iconOnly
        aria-label="Help"
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
        sx={{ minWidth: "1.75rem", width: "1.75rem", height: "1.75rem", p: 0, ...sx }}
      >
        <Icon fontSize="small">priority_high</Icon>
      </MDButton>
    </Tooltip>
  );
}

HelpTooltip.defaultProps = {
  placement: "bottom",
  sx: {},
};

HelpTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
  sx: PropTypes.objectOf(PropTypes.any),
};

export default HelpTooltip;
